import React from "react";
import kidWavingSrc from "Assets/kidWaving.png";

function KidWaving() {
   return <img className="surahs-overview-section__kid-img" src={kidWavingSrc} alt="kid" />;
}

export default KidWaving;
